var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"parametric-flats"},_vm._l((_vm.flats),function(flat){return _c('ParametricFlat',{key:flat.id,attrs:{"flat-data":flat,"is-mobile":_vm.isMobile}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }